<template>
  <v-container>
    <markdown-docs path="terms_of_use" />
    <v-row>
      <v-col class="text-center">
        <router-link to="/terms_jp">
          Terms of Use (Japanese) - 日本語利用規約
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MarkdownDocs from '@/components/MarkdownDocs.vue'

export default {
  title: 'terms',
  components: {
    MarkdownDocs,
  },
  data: () => ({}),
}
</script>
